import React from 'react';
import { Input, Upload, Row, Col, Tooltip, Icon, Spin } from 'antd';
import { pathOr } from 'ramda';
import DisabledPopup from './disabledPopup.js';
import ConfirmPopup from './confirmPopup.js';
const { TextArea } = Input;

class Demonstration extends React.Component {
  state = {
    what_learned: '',
    how_learned: '',
    accomplishments: '',
    notes: '',
    disabledPopup: false,
    confirmPopup: false,
    uploading: false
  };

  componentDidMount = () => {
    const { data } = this.props;
    if (data) {
      this.setState({
        what_learned: data.what_learned,
        how_learned: data.how_learned,
        accomplishments: data.accomplishments,
        notes: data.notes
      });
    }
  };

  componentWillUnmount = () => {
    this.saveData();
  };

  uploadFile = file => {
    this.setState({ uploading: true });
    const { firebase, uid, editingId } = this.props;
    let documents = (this.props.data && this.props.data.documents) || [];
    firebase
      .uploadFile(`/projects/${uid}/${editingId}/Demonstration`, file.file)
      .then(snapshot => {
        documents.push({
          url: snapshot.uploadTaskSnaphot.metadata.downloadURLs[0],
          name: file.file.name
        });
        firebase
          .database()
          .ref(`/projects/${uid}/${editingId}/Demonstration/documents/`)
          .set(documents);
        this.setState({ uploading: false });
      });
  };

  deleteFile = url => {
    const { firebase, uid, editingId } = this.props;
    const path = firebase.storage().refFromURL(url).location.path;
    firebase.deleteFile(path);
    let documents = this.props.data && this.props.data.documents;
    documents = documents && documents.filter(item => item.url !== url);
    firebase
      .database()
      .ref(`/projects/${uid}/${editingId}/Demonstration/documents`)
      .set(documents);
  };

  saveData = toNextPhase => {
    let data = {
      Demonstration: {
        documents: pathOr(null, ['data', 'documents'], this.props),
        what_learned: this.state.what_learned,
        how_learned: this.state.how_learned,
        accomplishments: this.state.accomplishments,
        is_complete: true,
        notes: this.state.notes
      }
    };
    if (toNextPhase) {
      data.current_phase = false;
      data.status = 'complete';
      this.props.saveData(data, true);
    } else {
      this.props.saveData(data);
    }
  };

  render() {
    const { color, t, disabled, projectCompleted } = this.props;
    const documents = this.props.data && this.props.data.documents;
    const { uploading } = this.state;
    const loadingIcon = (
      <Icon
        type="loading"
        style={{ fontSize: 24, marginLeft: 10, color }}
        spin
      />
    );
    const styles = {
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        alignSelf: 'left'
      },
      uploadBtn: {
        fontSize: 20,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: '0 2px 3px 0 rgba(0,0,0,0.5)'
      },
      nextBtn: {
        fontSize: 16,
        backgroundColor: this.props.color,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'pointer'
      },
      disabledNextBtn: {
        fontSize: 16,
        backgroundColor: '#d0d0d0',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'not-allowed'
      }
    };

    return (
      <div style={{ position: 'absolute', width: '100%', top: 260 }}>
        <div style={{ maxWidth: 650, margin: '0 auto', paddingBottom: 70 }}>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('What did I learn?')}</h3>
            <Tooltip title="What knowledge, facts or skills did you learn as part of this service learning experience">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ what_learned: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.what_learned}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('How did I learn?')}</h3>
            <Tooltip title="Describe the main ways that you learned during this service learning experience. Eg research, experience, experimentation">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ how_learned: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.how_learned}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('What did you advance/accomplish/contribute to?')}
            </h3>
            <Tooltip title="Explain how your experience has contributed to increasing knowledge, accomplishing new skills or contributing to the better well being of the environment, animals or people">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ accomplishments: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.accomplishments}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Notes')}</h3>
            <Tooltip title="Use the notes box if you'd like to add more information or reflections that you haven't included in the other sections.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ notes: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.notes}
            />
          </div>

          <div style={styles.titleDiv}>
            <div>
              <div style={{ display: 'flex' }}>
                <h3 style={styles.title}>
                  {t('Upload presentation / document')}
                </h3>
                {uploading && <Spin indicator={loadingIcon} />}
              </div>
              <p
                style={{
                  fontFamily: 'Helvetica Neue',
                  fontSize: 12,
                  margin: 0,
                  color: color
                }}>
                {t('(Maximum 5 attachments)')}
              </p>
            </div>
            {!projectCompleted && !disabled && (
              <Upload customRequest={this.uploadFile} showUploadList={false}>
                <div style={styles.uploadBtn}>+</div>
              </Upload>
            )}
          </div>
          <Row style={{ width: '100%' }}>
            {documents &&
              documents.length > 0 &&
              this.props.data.documents.map(item => (
                <Col xs={24} style={{ padding: 0, marginTop: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <a href={item.url} target="_blank">
                      <span>{item.name}</span>
                    </a>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.deleteFile(item.url)}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>
        </div>
        {!projectCompleted && (
          <DisabledPopup
            open={this.state.disabledPopup}
            close={() => this.setState({ disabledPopup: false })}
            color={color}
          />
        )}
        <div
          onClick={() =>
            !projectCompleted
              ? this.setState({ confirmPopup: true })
              : !projectCompleted && this.setState({ disabledPopup: true })
          }
          style={
            projectCompleted || disabled || this.props.currentPhase !== 5
              ? styles.disabledNextBtn
              : styles.nextBtn
          }>
          {t('Submit Project')}
        </div>
        <ConfirmPopup
          open={this.state.confirmPopup}
          close={() => this.setState({ confirmPopup: false })}
          color={color}
          submit={() => this.saveData(true)}
        />
      </div>
    );
  }
}

export default Demonstration;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/demonstration.js